// VC2 messages
const VC2_MESSAGE_TYPE = {
    PRE: 'PRE', // preamble
    NMB: 'NMB', // no more bets
    RES: 'RES',	// results
    RESTD: 'RESTD',
    VID: 'VID', // video
};

const PROTOCOL = {
    INIT: 'init',
    LOADED: 'loaded',
    NEVER: 'NEVER',
    GET_STATE: 'getState',
    STARTGAME: 'startGame',
    CONTINUEGAME: 'continueGame',
    ENDGAME: 'endGame',
    CHECKPOINT: 'checkpoint',
    EVENT_IDS: 'EVENTS',
    GAMECYCLE_ID: 'GAMECYCLE_ID',
    ILLUMINATE_BUTTONS: 'illuminateButtons',
    STATE_CHANGE_EVENT: 'session.StateChangeEvent',
    RESULT_EVENT: 'content.ResultEvent',
    ERROR_FAULT_CODE: 'ERROR_FAULT_CODE',
    PLATFORM_EVENT: 'platform.PlatformEvent',
    INVALID_CARD_EVENT: 'invalidcard.InvalidCardEvent'
};

const LOG_PREFIX = 'IKernelClient: ';
const LOG_PREFIX_QUEUE = 'IKernelClientQueue: ';

const LOGS = {
    // iKernelClient
    ERROR_MISSING_START_PARAMETERS: LOG_PREFIX + 'Missing constructor parameters',
    QUEUEING_INIT: LOG_PREFIX + 'Queueing init',
    QUEUEING_LOAD: LOG_PREFIX + 'Queueing load',
    QUEUEING_STARTGAME: LOG_PREFIX + 'Queueing startGame',
    QUEUEING_CONTINUEGAME: LOG_PREFIX + 'Queueing continueGame',
    QUEUEING_CHECKPOINT: LOG_PREFIX + 'Queueing checkpoint',
    QUEUEING_ENDGAME: LOG_PREFIX + 'Queueing endGame',
    QUEUEING_LIGHT_STATUS: LOG_PREFIX + 'Queueing buttons light status',
    RECEIVED_ERROR: LOG_PREFIX + 'Received error with data',
    SHUTING_DOWN_ERROR: LOG_PREFIX + 'SHUTING DOWN - Received error from iKernel ',
    SHUTING_DOWN_KILL_COMMAND: LOG_PREFIX + 'SHUTING DOWN - Received kill from iKernel ',
    WITH_DATA: LOG_PREFIX + 'With data',
    RECEIVED_INIT: LOG_PREFIX + 'Init received',
    RECEIVED_LOADED: LOG_PREFIX + 'Loaded received',
    QUEUEING_PLAYER_DATA_REQUEST: LOG_PREFIX + 'Queueing request to get new player data',
    RECEIVED_NEW_PLAYER_DATA: LOG_PREFIX + 'Received new player data #',
    RECEIVED_STARTGAME: LOG_PREFIX + 'Received response to startGame #',
    RECEIVED_CONTINUEGAME: LOG_PREFIX + 'Received response to continueGame #',
    RECEIVED_CHECKPOINT: LOG_PREFIX + 'Received response to checkpoint #',
    RECEIVED_ENDGAME: LOG_PREFIX + 'Received response to endGame #',
    MESSAGE_NOT_RECOGNIZED: LOG_PREFIX + 'The data received is not recognized',
    RECEIVED_EVENT_STATE_CHANGE: LOG_PREFIX + 'Received session.StateChangeEvent',
    RECEIVED_EVENT_RESULT: LOG_PREFIX + 'Received RECEIVED_EVENT_RESULT',
    RECEIVED_EVENT_PLATFORM: LOG_PREFIX + 'Received platform event',
    RECEIVED_EVENT_INVALID_CARD: LOG_PREFIX + 'Received invalid card event',

    // iKernelQueue
    ERROR_REMOVING_FROM_QUEUE: LOG_PREFIX_QUEUE + 'Error removing from queue',
    SENDING_MESSAGE: LOG_PREFIX_QUEUE + 'Sending message #',
    WITH_DATA_QUEUE: LOG_PREFIX_QUEUE + 'With data',
    ERROR_WRITING_TO_WEBSOCKET: LOG_PREFIX_QUEUE + 'Error writing to websocket',
};

module.exports = {
    VC2_MESSAGE_TYPE,
    LOG_PREFIX,
    PROTOCOL,
    LOGS,
};



// WEBPACK FOOTER //
// ./src/constants/communications.js